import { createSlice } from "@reduxjs/toolkit";
import {
  fetchServicesProvider,
  fetchServicesChecklist,
  fetchServicesListItems,
  updateServiceList,
} from "./ServicesActions";
import { getApiErrorMessage } from "../../../utils/commonUtilities";

const practiceServicesList = createSlice({
  name: "practiceServicesList",
  initialState: {
    isServicesLoading: false,
    servicesData: [],
    servicesError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchServicesProvider.pending, (state) => {
        state.isServicesLoading = true;
        state.servicesError = null;
      })
      .addCase(fetchServicesProvider.fulfilled, (state, action) => {
        state.isServicesLoading = false;
        if (!action.payload.success) {
          state.servicesError = true;
          state.servicesError = getApiErrorMessage(action.payload.status);
        } else {
          state.isServicesLoading = false;
          state.servicesData =
          action.payload.data.data.accessPointBriefResponseDTO.items;
        }
      })
      .addCase(fetchServicesProvider.rejected, (state, action) => {
        state.isServicesLoading = false;
        state.servicesError = action.error.message;
      });
  },
});

const practiceServicesChecklist = createSlice({
  name: "practiceServicesChecklist",
  initialState: {
    isServicesCheckLoading: false,
    servicesCheckData: [],
    servicesCheckError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchServicesChecklist.pending, (state) => {
        state.isServicesCheckLoading = true;
        state.servicesCheckError = null;
      })
      .addCase(fetchServicesChecklist.fulfilled, (state, action) => {
        state.isServicesCheckLoading = false;
        if (!action.payload.success) {
          state.servicesCheckError = true;
          state.servicesCheckError = getApiErrorMessage(action.payload.status);
        } else {
          state.isServicesCheckLoading = false;
          state.servicesCheckData = action.payload.data.data.bundleCategoryDTO;
        }
      })
      .addCase(fetchServicesChecklist.rejected, (state, action) => {
        state.isServicesCheckLoading = false;
        state.servicesCheckError = action.error.message;
      });
  },
});

const practiceServicesListItems = createSlice({
  name: "practiceServicesListItems",
  initialState: {
    isServicesListItemsLoading: false,
    servicesListItemsData: [],
    servicelistErrMsg: "",
    servicesListItemsError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchServicesListItems.pending, (state) => {
        state.isServicesListItemsLoading = true;
        state.servicesListItemsError = null;
      })
      .addCase(fetchServicesListItems.fulfilled, (state, action) => {
        if (!action.payload.success) {
          if (
              action.payload.data.metadata?.outcome.additionalDetails[0]
                ?.additionalInfo
            ){
              state.isServicesListItemsLoading = false;
              state.servicesListItemsData = [];
              state.servicesListItemsError = false;
            } else {
              state.isServicesListItemsLoading = false;
              state.servicesListItemsError = true;
              state.servicelistErrMsg = getApiErrorMessage(action.payload.status);
            }
        } else {
          state.isServicesListItemsLoading = false;
          state.servicesListItemsData =
            action.payload.data.data.bundleCategoryDTO;
        }
        
      })
      .addCase(fetchServicesListItems.rejected, (state, action) => {
        state.isServicesListItemsLoading = false;
        state.servicesListItemsError = action.error.message;
      });
    builder
      .addCase(updateServiceList.pending, (state) => {
        state.isServicesListItemsLoading = true;
        state.servicesListItemsError = null;
      })
      .addCase(updateServiceList.fulfilled, (state, action) => {
        state.isServicesListItemsLoading = false;
        if(!action.payload.success){
          state.servicesListItemsError = true;
          state.servicelistErrMsg = getApiErrorMessage(action.payload.status);
        } 
        else{
          state.isServicesListItemsLoading = false;
          state.servicesListItemsData =
          action.payload.data.data.bundleCategoryDTO;
        }
        
      })
      .addCase(updateServiceList.rejected, (state, action) => {
        state.isServicesListItemsLoading = false;
        state.servicesListItemsError = action.error.message;
      });
  },
});

export const practiceServicesListReducer = practiceServicesList.reducer;
export const practiceServicesChecklistReducer =
  practiceServicesChecklist.reducer;
export const practiceServicesListItemsReducer =
  practiceServicesListItems.reducer;
